export const ORIGINS = ["Tavsiye", "Instagram", "Facebook", "Telefon araması", "Web sitesi", "Mevcut müşteri", "Online teklif linki", "Diğer"];
export const MODES = ["Telefon", "Online", "Yüz Yüze"];
export const RESULTS = ["Tamamlandı", "Düşünecek", "Düşünmüyor", "Çalışılacak", "Çalışmayacak"];
export const RESULT_COLORS = { "Tamamlandı": "green", "Düşünecek": "amber", "Düşünmüyor": "slate", "Çalışılacak": "blue", "Çalışmayacak": "red" };
const MONTHS = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
const DAYS = ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];

export const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const todayStr = () => ymd(new Date());
const parse = (s) => new Date(`${s}T00:00:00`);
export const dayTitle = (s) => { const d = parse(s); return `${d.getDate()} ${MONTHS[d.getMonth()]} ${DAYS[d.getDay()]}`; };
export const monthTitle = (y, m) => `${MONTHS[m]} ${y}`;
export const fmtDate = (s) => (s ? s.split("-").reverse().join(".") : "");
export const sortAppts = (list) => [...list].sort((a, b) => `${a.date} ${a.time}`.localeCompare(`${b.date} ${b.time}`));

export const groupByDate = (list) => {
  const map = new Map();
  list.forEach((a) => { if (!map.has(a.date)) map.set(a.date, []); map.get(a.date).push(a); });
  return [...map.entries()];
};

export const fillTemplate = (text, a) => text
  .replaceAll("{ad}", a.customerName || "")
  .replaceAll("{tarih}", fmtDate(a.date))
  .replaceAll("{saat}", a.time || "")
  .replaceAll("{konu}", a.subject || "görüşme");

export const fullAddr = (x) => (x ? [x.address, [x.district, x.city].filter(Boolean).join(" / ")].filter(Boolean).join(", ") : "");
const pad = (n) => String(n).padStart(2, "0");
export const googleCalUrl = (a, addr) => {
  const s = new Date(`${a.date}T${a.time}:00`);
  const e = new Date(s.getTime() + 3600000);
  const stamp = (x) => `${x.getFullYear()}${pad(x.getMonth() + 1)}${pad(x.getDate())}T${pad(x.getHours())}${pad(x.getMinutes())}00`;
  const q = new URLSearchParams({ action: "TEMPLATE", text: `Randevu · ${a.customerName}${a.subject ? ` · ${a.subject}` : ""}`, dates: `${stamp(s)}/${stamp(e)}`, ctz: "Europe/Istanbul", details: [a.mode, a.phone, a.note].filter(Boolean).join("\n"), location: addr || "" });
  return `https://calendar.google.com/calendar/render?${q.toString()}`;
};
export const mapsUrl = (addr) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(addr)}`;
